import $ from 'jquery';
import _ from 'lodash';
import { isIE } from '../constants';

export default {
    bind(el, { value }) {
        const isForceAdd = _.get(value, 'forceAdd', false);
        if (!isIE && !isForceAdd) return;
        const padding = _.get(value, 'padding', 0);
        const iframe = $('<iframe class="directives__iframe" src=""/>');
        iframe.css({
            top: `-${padding}px`,
            left: `-${padding}px`,
            width: `calc(100% + ${2 * padding}px)`,
            height: `calc(100% + ${2 * padding}px)`,
            display: 'block',
            position: 'absolute',
            zIndex: '-1',
            border: 'none',
        });
        $(el).append(iframe);
    },
    unbind(el) {
        if (!isIE) return;
        $(el).find('.directives__iframe').remove();
    },
};
